import React from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const DeliveryInformation = ({
  transporters = [],
  value,
  onChange,
}) => {
  const options = transporters.map((item) => ({
    value: item.id,
    label: item.name || item.transporter_name,
  }));

  const selectedOption = options.find(
    (option) => option.value === value
  );

  return (
    <div className="position-relative">
      <i
        className="bi bi-truck"
        style={{
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#6c757d",
          zIndex: 10,
          cursor:"pointer"
          
        }}
      ></i>

      <Select
        className="w-100 "
        options={options}
        value={selectedOption || null}
        onChange={(selected) => {
          onChange(selected ? selected.value : "");
        }}
        placeholder="Select Transporter"
        isSearchable
        isClearable
        styles={{
          control: (base) => ({
            ...base,
            fontSize: "12px",
            paddingLeft: "28px", // space for icon
            cursor:"pointer"
          }),
          option: (base) => ({
            ...base,
            fontSize: "12px",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "12px",
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "12px",
          }),
          input: (base) => ({
            ...base,
            fontSize: "12px",
          }),
        }}
      />
    </div>
  );
};

export default DeliveryInformation;